import Icon from '../components/Icon';

const Block = Icon(
  'block',
  <>
    <path
      fillRule="evenodd"
      d="M4.58 4.221a.75.75 0 0 0-.359.36A10.71 10.71 0 0 0 1.25 12c0 5.937 4.813 10.75 10.75 10.75 2.877 0 5.49-1.13 7.42-2.972a.75.75 0 0 0 .358-.358A10.71 10.71 0 0 0 22.75 12c0-5.937-4.813-10.75-10.75-10.75-2.877 0-5.49 1.13-7.42 2.971m1.431.73A9.25 9.25 0 0 1 19.05 17.99zM17.989 19.05A9.2 9.2 0 0 1 12 21.25 9.25 9.25 0 0 1 4.95 6.011z"
      clipRule="evenodd"
    />
  </>
);

export default Block;
